export const removeQueryFromUrl = (queryToRemove: string) => {
    if (!queryToRemove) {
        return;
    }
    const currentUrl = window.location.href;

    // Remove the query param from the URL
    const regex = new RegExp("[\\?&]" + queryToRemove + "=[^&]*", "i");

    const updatedUrl = currentUrl.replace(regex, "");
    // Update the browser history without triggering a page reload
    window.history.replaceState(null, "", updatedUrl);
};

export const getQueryParam = (queryParam: string): string | null => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(queryParam);
};
